import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "utils/auth";

export default function RequireAuth({ children }) {
  const location = useLocation();
  const authenticated = isAuthenticated();
  if (!authenticated) {
    return (
      <Navigate to="/auth/sign-in" state={{ from: location }} replace />
    );
  }
  return children;
}
